import { useCallback, useMemo, useState } from 'react'

import { transformByPressLeftButton, transformByPressRightButton } from './helpers'
import type { ShowMode } from './types'

/**
 * Хук для манипуляции переменной размера нижней панели
 *
 * @returns литеральный размер панели, методы для изменения
 */
export const useFooter = (initialShowMode: ShowMode = 'none', noFullMode = false) => {
  const [showMode, setShowMode] = useState<ShowMode>(initialShowMode)

  const leftButton = useCallback(() => {
    const newMode = transformByPressLeftButton(showMode)

    setShowMode(newMode)
    return newMode
  }, [showMode])

  const rightButton = useCallback(() => {
    const newMode = transformByPressRightButton(showMode, noFullMode)

    setShowMode(newMode)
    return newMode
  }, [noFullMode, showMode])

  const setFull = useCallback(() => {
    if (noFullMode) return

    setShowMode('full')
  }, [noFullMode])

  const setHalf = useCallback(() => {
    setShowMode('half')
  }, [])

  const setNone = useCallback(() => {
    setShowMode('none')
  }, [])

  return useMemo(
    () => ({ showMode, setFull, setHalf, setNone, leftButton, rightButton }),
    [leftButton, rightButton, setFull, setHalf, setNone, showMode],
  )
}

export type FooterApi = ReturnType<typeof useFooter>
